import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';
import { InMemoryCacheService, UtilsService } from 'src/app/common';
import { AppMenuitemComponent } from '../menuitem/app.menuitem.component';
import { AppInlineMenuComponent } from '../inlinemenu/app.inlinemenu.component';

@Component({
    standalone: true,
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    imports: [
        CommonModule,
        AppMenuitemComponent,
        AppInlineMenuComponent
    ]
})
export class AppMenuComponent implements OnInit, OnDestroy {

    public model: any[];

    constructor(public app: AppComponent, public appMain: AppMainComponent, private router: Router,
        private cache: InMemoryCacheService, private utils: UtilsService) { }

    ngOnInit() {
       this.cache.mainMenu.subscribe((data) => {
            if (data) {
                this.utils.logger.info(`AppMenuComponent.ngOnInit() setting menu data`);
                this.model = data;
            }
       });
    }

    ngOnDestroy() {
       // this.cache.mainMenu.unsubscribe();
    }
}
